$(document).ready(function() {
  var setPaging = function() {
    $(".pagination-wrapper").hide();
    var page = 1;
    var section_id = $(".product-grid-container > .collection").parents(".shopify-section:first").attr("id").replace("shopify-section-", "");

    //$(".product-grid li").addClass("js-fadeUp");
    $(".product-grid li:last").data("last", 1);
    var url = location.href;
    if (url.match(/\?/)) {
      url += "&";
    } else {
      url += "?";
    }
    url += "section_id=" + section_id;
    
    //データ取得
    var getData = function() {
      url += "&page=" + page;
      $.ajax({
        type: "GET",
        url: url,
        data: {}
      }).done(function(res) {
        if ($(res).find(".product-grid li").length) {
          var $res = $(res);
          //$res.find(".product-grid li").addClass("js-fadeUp");
          $res.find(".product-grid li:last").data("last", 1);
          $(".product-grid").append($res.find(".product-grid li"));
          setPagingObserver();
        }
      });
    }

    
    var setPagingObserver = function() {
      let items = [].slice.call(document.querySelectorAll(".product-grid li"));
      let itemObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          // この要素が画面に入ってきた場合
          if (entry.isIntersecting) {
  
            let item = entry.target;
            let $item = $(item);
  
            if (!$item.hasClass("is-inview")) {
              $item.addClass("is-inview");
              setTimeout(function(){
                if ($item.hasClass("scroll-trigger--offscreen")) {
                  $item.removeClass("scroll-trigger--offscreen");//shopifyでやってくれるようだが消えないことがあるので明示的に消す
                }
              }, 50);
  
              //ページング実行
              var last = $item.data("last");
              if (last) {
                page++;
                $item.data("last", 0);
                getData();               
              }
            }
            // この画像要素を観察対象から外します
            itemObserver.unobserve(item);
          } else {
  
          }
  
        });
      });
      items.forEach(function(item) {
        // 観察を開始します
        itemObserver.observe(item);
      });
  
    }
    setPagingObserver();
  }
  // IntersectionObserver に対応しているブラウザのみ、処理を実行します
  if ("IntersectionObserver" in window) {
    setPaging();
    //タイプの選択やソート後
    $("#ProductGridContainer").on("renderProductGridContainer", function(){
      setPaging();
    })
  }
});
